import { createTheme } from '@mui/material/styles';

// FEAST デザインシステム（feast-design/design-system/tokens.css が正典）のトークンを MUI テーマへ適用する。
// 値を変える場合は tokens.css / src/styles/_variables.scss と三点同期すること。ADR 0029。
const theme = createTheme({
  palette: {
    primary: {
      main: '#F46B4D', // --color-primary（ブランドプライマリ）
      light: '#F68D75',
      dark: '#D94E30',
      contrastText: '#ffffff',
    },
    success: { main: '#4caf50' },
    error: { main: '#f44336' },
    warning: { main: '#ff9800' },
    info: { main: '#2196f3' },
    background: {
      default: '#f9f9f9', // --bg-light
      paper: '#ffffff',
    },
  },
  shape: {
    borderRadius: 8, // --r-base
  },
  typography: {
    fontFamily:
      "'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', 'Hiragino Sans', 'Noto Sans JP', sans-serif",
    // デフォルトのフォントサイズ
    h1: {
      fontSize: '24pt',
      '@media (max-width:390px)': {
        fontSize: '20pt',
      },
    },
    h2: {
      fontSize: '20pt',
      '@media (max-width:390px)': {
        fontSize: '18pt',
      },
    },
    h3: {
      fontSize: '18pt',
      '@media (max-width:390px)': {
        fontSize: '16pt',
      },
    },
    h4: {
      fontSize: '16pt',
      '@media (max-width:390px)': {
        fontSize: '14pt',
      },
    },
    h5: {
      fontSize: '14pt',
      '@media (max-width:390px)': {
        fontSize: '12pt',
      },
    },
    h6: {
      fontSize: '12pt',
      '@media (max-width:390px)': {
        fontSize: '11pt',
      },
    },
    body1: {
      fontSize: '11pt',
      '@media (max-width:390px)': {
        fontSize: '10pt',
      },
    },
    body2: {
      fontSize: '10pt',
      '@media (max-width:390px)': {
        fontSize: '9pt',
      },
    },
    button: {
      fontSize: '10pt',
      '@media (max-width:390px)': {
        fontSize: '9pt',
      },
    },
    caption: {
      fontSize: '9pt',
      '@media (max-width:390px)': {
        fontSize: '8pt',
      },
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          // 「開 始」「プレビュ ー」のようなボタン文言の途中改行を防ぐ（日本語はどこでも折り返されるため）。
          whiteSpace: 'nowrap',
          '@media (max-width:390px)': {
            padding: '6px 12px',
          },
        },
        // ボタンの段階（重要度）を色で表現する:
        //   重要な操作（会計・注文するなど）= contained（背景ブランドカラー）
        //   通常の操作 = outlined（背景白・文字/枠線ブランドカラー）
        // 画面ごとに variant を使い分けて操作の優先度を伝える。
        containedPrimary: {
          '&:hover': {
            backgroundColor: '#E15D40', // --color-primary-hover
          },
        },
        outlinedPrimary: {
          backgroundColor: '#fff', // 通常操作は白地＋ブランド文字で「重要操作より一段控えめ」を表す
          '&:hover': {
            backgroundColor: '#FDECE7', // ごく淡いブランド背景（--color-primary の tint）
          },
        },
        sizeSmall: {
          '@media (max-width:390px)': {
            padding: '4px 8px',
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          // iOS Safari は入力欄の font-size が 16px 未満だとフォーカス時に自動ズームする。
          // モバイルでは 16px に引き上げ、入力時の自動ズーム（＝画面が拡大して「次へ」ボタンが
          // 見切れる問題）を防ぐ。size="small" の余白は維持したままフォントのみ拡大する。
          '@media (max-width:600px)': {
            fontSize: 16,
          },
        },
      },
    },
  },
});

export default theme;
